<template>
  <EntityListItem
    icon="calendar"
    icon-tone="amber"
    :title="title"
    clickable
    @click="handleClick"
  >
    <template #subtitle>
      <span
        v-if="appointment.lead?.name && appointment.title"
        class="appointment-list-item__meta"
      >
        <BaseIcon name="user" size="11" />
        {{ appointment.lead.name }}
      </span>
      <span v-if="appointment.location" class="appointment-list-item__meta">
        <BaseIcon name="map-pin" size="11" />
        {{ truncate(appointment.location, 40) }}
      </span>
    </template>

    <template #right>
      <span class="appointment-list-item__when">
        <BaseIcon name="calendar-clock" size="11" />
        {{ whenText }}
      </span>
    </template>
  </EntityListItem>
</template>

<script>
  import { computed, getCurrentInstance } from 'vue';
  import { useRouter } from 'vue-router';
  import dayjs from 'dayjs';
  import EntityListItem from '@/components/partials/lists/EntityListItem.vue';
  import BaseIcon from '@shared/components/BaseIcon.vue';

  export default {
    name: 'AppointmentListItem',

    components: { EntityListItem, BaseIcon },

    props: {
      appointment: { type: Object, required: true },
    },

    emits: ['click'],

    setup(props, { emit }) {
      const instance = getCurrentInstance();
      const $t = instance.appContext.config.globalProperties.$t;
      const router = useRouter();

      const title = computed(
        () =>
          props.appointment.title ||
          props.appointment.lead?.name ||
          $t('home.appointments.untitled')
      );

      const whenText = computed(() => {
        const start = dayjs(props.appointment.start_at || props.appointment.start);
        if (!start.isValid()) return '';
        const today = dayjs().startOf('day');
        const tomorrow = today.add(1, 'day');
        const day = start.startOf('day');
        const time = start.format('HH:mm');
        if (day.isSame(today)) return `${$t('home.today')} ${time}`;
        if (day.isSame(tomorrow)) return `${$t('home.tomorrow')} ${time}`;
        return start.format('DD MMM HH:mm');
      });

      const truncate = (value, max) => {
        if (!value) return '';
        return value.length <= max ? value : `${value.slice(0, max - 1).trim()}…`;
      };

      const handleClick = () => {
        emit('click', props.appointment);
        router.push('/appointments');
      };

      return { title, whenText, truncate, handleClick };
    },
  };
</script>

<style scoped lang="scss">
  .appointment-list-item {
    &__meta {
      display: inline-flex;
      align-items: center;
      gap: 0.25rem;
    }

    &__when {
      display: inline-flex;
      align-items: center;
      gap: 0.25rem;
      font-size: 0.75rem;
      color: var(--slate-500);
      font-variant-numeric: tabular-nums;
      white-space: nowrap;

      .icon {
        color: var(--slate-400);
      }
    }
  }
</style>
